// extracted by mini-css-extract-plugin
export default {"dropdownButton":"SwitchButton_dropdownButton__cxGtU"};